import { DB_MAX, DB_MIN, DB_STEP } from "./audiometerChartConstants";

type AudiometerNoiseSliderProps = {
  label: string;
  value: number;
  onChange: (db: number) => void;
};

export default function AudiometerNoiseSlider({ label, value, onChange }: AudiometerNoiseSliderProps) {
  return (
    <div className="audiometer-noise-slider" aria-label={label} title={label}>
      <span className="audiometer-noise-slider__value">{value} dB</span>
      <div className="audiometer-noise-slider__track">
        <input
          type="range"
          min={DB_MIN}
          max={DB_MAX}
          step={DB_STEP}
          value={value}
          onChange={e => onChange(Number(e.target.value))}
          aria-label={label}
        />
      </div>
      <span className="audiometer-noise-slider__icon" aria-hidden="true">
        <i className="bi bi-soundwave" />
      </span>
    </div>
  );
}
